<span *ngIf="control.invalid">
  {{ errorMessage }}
</span>
